module.exports = __webpack_public_path__ + "static/img/privacy-8-3.70fa2e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/privacy-8-3.png
// module id = 5OtP
// module chunks = 1